import React, { Component } from 'react';
import { Container, Row, Col, Input } from 'reactstrap';
import './Demographics.css';
import 'bootstrap/dist/css/bootstrap.css';
import CompareDemographicsTable from './CompareDemographicsTable.js';
import CompanyContext from '../../auth/CompanyContext.js';

const clientList = [
  { type: '(a) Individuals', account: '5D(a)(1) number of accounts Individual', aum: '5D(a)(3) - AUM Individual' },
  { type: '(b) High Net Worth Individuals', account: '5D(b)(1)', aum: '5D(b)(3) AUM High Net Worth' },
  { type: '(c) Banking or Thrift Institutions', account: '5D(c)(1)', aum: '5D(c)(3)' },
  { type: '(d) Investment Companies', account: '5D(d)(1)', aum: '5D(d)(3)' },
  { type: '(e) Business Development Companies', account: '5D(e)(1)', aum: '5D(e)(3)' },
  { type: '(f) Pooled Investment Vehicles', account: '5D(f)(1)', aum: '5D(f)(3)' },
  { type: '(g) Pension and Profit Sharing Plans', account: '5D(g)(1) # acts INST', aum: '5D(g)(3) - AUM INST' },
  { type: '(h) Charitable Organizations', account: '5D(h)(1)', aum: '5D(h)(3)' },
  { type: '(i) State/Municipal Government Entities', account: '5D(i)(1)', aum: '5D(i)(3)' },
  { type: '(j) Other Investment Advisers', account: '5D(j)(1)', aum: '5D(j)(3)' },
  { type: '(k) Insurance Companies', account: '5D(k)(1)', aum: '5D(k)(3)' },
  { type: '(l) Sovereign Wealth Funds / Foreign Insitutions', account: '5D(l)(1)', aum: '5D(l)(3)' },
  { type: '(m) Other Businesses Not Listed Above', account: '5D(m)(1)', aum: '5D(m)(3)' },
  { type: '(n) Family Foundations', account: '5D(n)(1)', aum: '5D(n)(3)' }
];

const totalList = [
  { type: 'Discretionary', account: '5F(2)(d) # acts Disc', aum: '5F(2)(a) - AUM Disc' },
  { type: 'Non-Discretionary', account: '5F(2)(e) # acts non-disc', aum: '5F(2)(b) AUM- non-disc' },
  { type: 'Total', account: '5F(2)(f) Total # accts.', aum: '5F(2)(c) AUM Total' }
];

class CompareDemographics extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);
    this.available_dates = props.available_dates;
    this.newID = String(this.props.location.pathname).split('/')[2];
    this.secID = '';
    this.orgID = 0;
    String(this.newID).split('_').forEach(item => {
      if (item.indexOf('-') === -1 && Number.isInteger(parseInt(item))) {
        this.orgID = item;
      } else if (item.indexOf('-') > -1) {
        this.secID = item;
      }
    })
    this.state = {
      currentDate: ("location" in this.props &&
        "state" in this.props.location && this.props.location.state != null &&
        "currentDate" in this.props.location.state &&
        this.props.location.state.currentDate != null)
        ? this.props.location.state.currentDate
        : this.props.available_dates[this.props.available_dates.length - 1].date_key,
      companies: [],
      secID: this.secID,
      orgID: this.orgID,
      searchState: (this.props.location.state != null && "searchState" in this.props.location.state) ? this.props.location.state.searchState : null,
      clientListFilteredAll: [],
      totalListFilteredAll: [],
      linkedCompanies: []
    };
  };

  componentDidMount() {
    this.setState(
      { loading: true },
      () => {
        this.getLinkedCompanies();
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
      this.setState(
        { loading: true },
        () => {
          this.getLinkedCompanies();
        }
      );
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  handleDateInputChange = (e) => {
    e.persist();

    if (e.target.name === 'current_date') {
      this.setState(
        { loading: true, currentDate: e.target.value },
        () => {
          this.getLinkedCompanies();
        }
      );

    }
  }

  getLinkedCompanies = (secID = this.state.secID, companyPosition = 0) => {
    fetch('/api/linkedCompanies/' + secID + '/' + this.state.currentDate, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        let linkedCompanies = [this.state.secID];
        if (results.data.length > 0) results.data[0].children.forEach(child => linkedCompanies.push(child['SEC#']));
        this.setState({
          companies: [],
          linkedCompanies: linkedCompanies
        }, () => {
          this.state.linkedCompanies.forEach((child, index) => this.getItems(child, index));
        });
      });
    return;
  }

  getItems = (secID = this.state.secID, companyPosition = 0) => {
    fetch('/api/demographics/' + secID + '/' + this.state.currentDate, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        this.setState((prevState, props) => {
          let companies = prevState.companies;
          if (companies[companyPosition] === undefined) companies[companyPosition] = {
            data: [], secID: '', clientListFiltered: [], totalListFiltered: [], clientAUMTotal: 0, clientAccountTotal: 0
          };
          companies[companyPosition].data = results.data;
          companies[companyPosition].secID = secID;
          let return_value = {
            loading: false,
            companies: companies
          };
          return return_value;
        }, () => this.combineTotals());
      });
    return;
  }

  combineTotals = () => {
    let clientListFilteredAll = [];
    let totalListFilteredAll = [];

    this.state.companies.forEach(company => {

      company.clientListFiltered = clientList.filter(c => company.data[c.aum] > 0);
      clientListFilteredAll = [...new Set([...clientListFilteredAll, ...company.clientListFiltered])];
      clientListFilteredAll.sort(function (a, b) {
        var textA = a.type.toUpperCase();
        var textB = b.type.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });

      company.totalListFiltered = totalList.filter(c => company.data[c.aum] > 0);
      totalListFilteredAll = [...new Set([...totalListFilteredAll, ...company.totalListFiltered])];
      totalListFilteredAll.sort(function (a, b) {
        var textA = a.account.toUpperCase();
        var textB = b.account.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });

      // console.log(clientListFilteredAll, totalListFilteredAll);
      company.clientAUMTotal = 0;
      company.clientAccountTotal = 0;
      company.clientListFiltered.forEach(i => {
        company.clientAUMTotal += parseFloat(company.data[i.aum]);
        company.clientAccountTotal += parseFloat(company.data[i.account]);
      });

      this.setState({
        clientListFilteredAll: clientListFilteredAll,
        totalListFilteredAll: totalListFilteredAll
      })

    });
  }

  render() {
    if (this.state.companies.length > 0) {

      return (<div className="multiWrapper">
        <Container fluid={true} className="demographicsContainer h-100">
          <Row className="align-items-center">
            <Col md="6"><h3>Master Company Comparison</h3></Col>
            <Col md="2" className="text-right"><p>Data as of</p></Col>
            <Col md="4">
              <Input
                type="select"
                name="current_date"
                onChange={e => this.handleDateInputChange(e)}
                value={this.state.currentDate.substr(0, 2) + this.state.currentDate.substr(2, 2) + this.state.currentDate.substr(4, 2)}
              >
                {this.available_dates.map(d => (
                  <option value={d.date_key} key={'current_date_' + d.date_string}>{d.date_string}</option>
                ))}
              </Input>
            </Col>
          </Row>
        </Container>

        <div className="tableContainer tableContainerFixed">
          <CompareDemographicsTable clientToken={this.props.clientToken} {...this.state} />
        </div>

        <div className="tableContainer tableContainerScroll">
          <CompareDemographicsTable clientToken={this.props.clientToken} {...this.state} />
        </div>
      </div>
      );
    } else {
      return (
        <Container>
          <h1>Advisor Demographics</h1>
          <p>Loading...</p>
        </Container>
      );
    }
  }
}

export default CompareDemographics;